import gsap from 'gsap';

export default class Awards {
  constructor() {
    this.logos = document.querySelector('.s-awards-logos');
    this.logo = document.querySelectorAll('.s-awards-logo');
  }

  set = () => {
    gsap.set(this.logo, {
      y: 25,
      opacity: 0,
    });
  }

  inview = () => {
    const { top, bottom } = this.logos.getBoundingClientRect();

    if (top < window.innerHeight * 0.7 && bottom > 0) {
      this.animate();
      this.destroy();
    }
  }

  animate = () => {
    if (this.animate === true) return;
    gsap.to(this.logo, {
      y: 0,
      opacity: 1,
      duration: 1.5,
      stagger: 0.15,
      ease: 'expo.out',
    });
  }

  destroy() {
    gsap.ticker.remove(this.inview);
  }

  init = () => {
    this.set();
    gsap.ticker.add(this.inview);
  }
}
